import * as React from "react";
import { useHistory } from "react-router-dom";
import { Job } from "../../../../generated/nest-graphql";
import { Chip, ChipColor, ChipSize, ForwardIcon, Pressable, Text, TextVariant, useBrandColors } from "../../../ui";

/** The job's number in orange with an arrow, opening it; the job the technician is on is marked instead. */
export const JobLink: React.FC<{ job: Job; isCurrent: boolean }> = ({ job, isCurrent }) => {
  const history = useHistory();
  const { primary } = useBrandColors();
  const number = `#${job.jobNumber ?? "—"}`;
  if (isCurrent || !job.id) {
    return (
      <span className="flex items-center gap-1.5 shrink-0">
        {isCurrent && (
          <Chip
            size={ChipSize.SMALL}
            label="Current"
            color={ChipColor.PRIMARY}
            style={{ height: 20, fontSize: 11, fontWeight: 600 }}
          />
        )}
        <Text variant={TextVariant.BODY2} style={{ fontWeight: 700, color: primary }}>
          {number}
        </Text>
      </span>
    );
  }
  return (
    <Pressable
      aria-label={`Open job ${number}`}
      onClick={() => history.push(`/jobs/${job.id}`)}
      // A 44px-tall tap target that does not make the header taller.
      style={{ minHeight: 44, margin: "-10px -6px -10px 0", padding: "0 6px", borderRadius: 4, flexShrink: 0 }}
    >
      <Text as="span" variant={TextVariant.BODY2} style={{ fontWeight: 700, color: primary }}>
        {number}
      </Text>
      <ForwardIcon aria-hidden style={{ fontSize: 13, marginLeft: 4, color: primary }} />
    </Pressable>
  );
};
